/* =========================================================================
   EGONEX — Genel arayüz yardımcıları
   - Yukarı çık butonu
   - Kaydırınca belirme (.eg-reveal)
   - Mobil alt navigasyon barı
   ========================================================================= */
(function () {
  'use strict';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------------------------------------------------------- YUKARI ÇIK */
  function initToTop() {
    const btn = document.querySelector('[data-eg-to-top]');
    if (!btn) return;

    let ticking = false;
    const update = () => {
      btn.classList.toggle('is-visible', window.scrollY > 500);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
    });

    update();
  }

  /* ------------------------------------------------------------ REVEAL */
  function initReveal() {
    const items = document.querySelectorAll('.eg-reveal');
    if (!items.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach((el) => io.observe(el));
  }

  /* -------------------------------------------------- MOBİL ALT BAR */
  function initMobileBar() {
    const bar = document.querySelector('[data-eg-mobile-bar]');
    if (!bar) return;

    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      // Aşağı kaydırırken gizle, yukarı kaydırırken göster
      bar.classList.toggle('is-hidden', y > lastY && y > 240);
      lastY = y;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    document.addEventListener('eg:overlay:open', () => bar.classList.add('is-tucked'));
    document.addEventListener('eg:overlay:close', () => bar.classList.remove('is-tucked'));

    // Sepet butonu çekmeceyi açsın
    const cartLink = bar.querySelector('[data-eg-mobile-cart]');
    const drawer = document.querySelector('cart-drawer');
    if (cartLink && drawer) {
      cartLink.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.open(cartLink);
      });
    }
  }

  function init() {
    initToTop();
    initReveal();
    initMobileBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
